import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as settingsActions from '../../../redux/actions/SettingsActions';
import { getFunds } from '../../../redux/actions/FundsActions';

import { isValidEmail,concatenateGeosuggestLabel } from '../../../lib/utils';
import { TagNames, SettingNames, PartialSettings } from '../../../lib/constants';

import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';

import SettingsMenu from '../SettingsMenu';
import TagInput from './TagInput';
import CampaignSettings from './campaignSettings/CampaignSettings';
import ApplyCancelInput from './ApplyCancelInput';
import UpdateSelect from './UpdateSelect';
import ReturnAddress from './paymentSettings/ReturnAddress';
import Signatures from './paymentSettings/Signatures';
import CloudPrint from './CloudPrint';
import FlushAiSummaries from './FlushAiSummaries';

import CurrencyConversionInput from "./paymentSettings/CurrencyConversionInput";

class SystemSettingsPage extends React.Component {

    componentWillMount() {
        this.props.actions.getSystemSettings();
        this.props.actions.getFunds();
    }

        validateEmail(email) {
            const isValid = isValidEmail(email);
            this.setState({ invalidData: !isValid });
            return isValid;
        }
    

    render() {
        const { settings, updatingSettings, tags, reloadingSettings, loading } = this.props;
        return (
            <div className="page">
                <div className="settings-page relative">
                    <div className="subheader">
                        <div className="container flex-justify flex-center">
                            <SettingsMenu />
                        </div>
                    </div>
                    <div className="container">

                        {loading && <div className="settings-loader"><LoadingSpinner height="20" /></div>}

                        <p className="section-header">Payment Settings</p>
                        <div className="flex-justify settings-section payment-settings">
                            <div className="column-half column-half-left">
                                <ApplyCancelInput input={<CurrencyConversionInput />}
                                    title="Shekel Conversion Rate"
                                    value={settings.paymentSettings.currencyConversionRate.value}
                                    loading={updatingSettings.currencyConversionRate.loading}
                                    success={updatingSettings.currencyConversionRate.success}
                                    update={this.props.actions.updateSetting.bind(this, SettingNames.CurrencyConversionRate, settings.paymentSettings.currencyConversionRate.id)} />
                                <ReturnAddress address={settings.paymentSettings.returnAddress}
                                    addressLabel={concatenateGeosuggestLabel(settings.paymentSettings.returnAddress, false)}
                                    unitTypes={settings.otherSettings.unitTypes}
                                    update={this.props.actions.updateReturnAddress}
                                    loading={updatingSettings.returnAddress.loading}
                                    success={updatingSettings.returnAddress.success} />
                            </div>
                            <div className="column-half column-half-right">
                                <Signatures
                                    signatures={this.props.settings.paymentSettings.signatures}
                                    funds={tags.funds}
                                    addSignature={this.props.actions.saveSignature}
                                    adding={updatingSettings.signatures}
                                    reloadPaymentSettings={this.props.actions.getPartialSystemSettings.bind(this, PartialSettings.PaymentSettings)}
                                    loading={reloadingSettings.paymentSettings.loading} />
                            </div>
                        </div>
                        

                        <p className="section-header">Recipient Settings</p>
                        <div className="flex-justify settings-section">
                            <div className="column-half column-half-left">
                                <TagInput title="Individual Categories"
                                    values={settings.recipientSettings.individualTags}
                                    sort={true}
                                    add={this.props.actions.addTag.bind(this, TagNames.IndividualTags)}
                                    name='category'
                                    adding={updatingSettings.individualTags.add}
                                    deleting={updatingSettings.individualTags.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.IndividualTags)} />

                                <TagInput title="US Person Titles"
                                    values={settings.recipientSettings.usPersonTitles}
                                    sort={true}
                                    add={this.props.actions.addTag.bind(this, TagNames.USPersonTitles)}
                                    name='title'
                                    adding={updatingSettings.usPersonTitles.add}
                                    deleting={updatingSettings.usPersonTitles.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.USPersonTitles)}
                                    allowUpdate={true}
                                    update={this.props.actions.updateTag.bind(this, TagNames.USPersonTitles)}
                                    updating={updatingSettings.usPersonTitles.update} />

                                <TagInput title="Israel Person Titles"
                                    values={settings.recipientSettings.israelPersonTitles}
                                    sort={true}
                                    add={this.props.actions.addTag.bind(this, TagNames.IsraelPersonTitles)}
                                    name='title'
                                    adding={updatingSettings.israelPersonTitles.add}
                                    deleting={updatingSettings.israelPersonTitles.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.IsraelPersonTitles)}
                                    allowUpdate={true}
                                    update={this.props.actions.updateTag.bind(this, TagNames.IsraelPersonTitles)}
                                    updating={updatingSettings.israelPersonTitles.update} />

                            </div>
                            <div className="column-half column-half-right">
                                <TagInput title="Organization Categories"
                                    values={settings.recipientSettings.organizationTags}
                                    sort={true}
                                    add={this.props.actions.addTag.bind(this, TagNames.OrganizationTags)}
                                    name='category'
                                    adding={updatingSettings.organizationTags.add}
                                    deleting={updatingSettings.organizationTags.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.OrganizationTags)} />

                                <TagInput title="US Institution Titles"
                                    values={settings.recipientSettings.usInstitutionTitles}
                                    sort={true}
                                    add={this.props.actions.addTag.bind(this, TagNames.USInstitutionTitles)}
                                    name='title'
                                    adding={updatingSettings.usInstitutionTitles.add}
                                    deleting={updatingSettings.usInstitutionTitles.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.USInstitutionTitles)}
                                    allowUpdate={true}
                                    update={this.props.actions.updateTag.bind(this, TagNames.USInstitutionTitles)}
                                    updating={updatingSettings.usInstitutionTitles.update} />

                                <TagInput title="Israel Institution Titles"
                                    values={settings.recipientSettings.israelInstitutionTitles}
                                    sort={true}
                                    add={this.props.actions.addTag.bind(this, TagNames.IsraelInstitutionTitles)}
                                    name='title'
                                    adding={updatingSettings.israelInstitutionTitles.add}
                                    deleting={updatingSettings.israelInstitutionTitles.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.IsraelInstitutionTitles)}
                                    allowUpdate={true}
                                    update={this.props.actions.updateTag.bind(this, TagNames.IsraelInstitutionTitles)}
                                    updating={updatingSettings.israelInstitutionTitles.update} />
                            </div>
                        </div>

                        <p className="section-header">Application Settings</p>
                        <div className="flex-justify settings-section">
                            <div className="column-half column-half-left">
                                <TagInput title="Individual Application Reasons"
                                    values={settings.applicationSettings.individualApplicationReasons}
                                    add={this.props.actions.addTag.bind(this, TagNames.IndividualApplicationReasons)}
                                    name='reason'
                                    adding={updatingSettings.individualApplicationReasons.add}
                                    deleting={updatingSettings.individualApplicationReasons.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.IndividualApplicationReasons)} />
                                </div>
                            <div className="column-half column-half-right">
                                <TagInput title="Organization Application Reasons"
                                    values={settings.applicationSettings.organizationApplicationReasons}
                                    add={this.props.actions.addTag.bind(this, TagNames.OrganizationApplicationReasons)}
                                    name='reason'
                                    adding={updatingSettings.organizationApplicationReasons.add}
                                    deleting={updatingSettings.organizationApplicationReasons.delete}
                                    delete={this.props.actions.deleteTag.bind(this, TagNames.OrganizationApplicationReasons)} />
                            </div>
                        </div>

                        <p className="section-header">Campaign Settings</p>
                        <div className="column-half column-half-left">
                                <ApplyCancelInput input={<input type="text" />}
                                    title="Email From Address"
                                    value={settings.campaignSettings.fromEmailAddress.value}
                                    loading={updatingSettings.fromEmailAddress.loading}
                                    success={updatingSettings.fromEmailAddress.success}
                                    update={this.props.actions.updateSetting.bind(this, SettingNames.FromEmailAddress, settings.campaignSettings.fromEmailAddress.id)} 
                                    validate={this.validateEmail.bind(this)} errorMessage="Invalid Email Address" />
                        </div>
                        <CampaignSettings settings={settings.campaignSettings}
                            categories={updatingSettings.campaignCategories}
                            individualCategories={updatingSettings.campaignIndivCategories}
                            locations={updatingSettings.campaignLocationGroups}
                            addSetting={this.props.actions.addTag}
                            deleteSetting={this.props.actions.deleteTag}
                            updateLocationGroup={this.props.actions.updateLocationGroup}
                            reloadCampaignSettings={this.props.actions.getPartialSystemSettings.bind(this, PartialSettings.CampaignSettings)}
                            loading={reloadingSettings.campaignSettings.loading}
                            categoryTypes={settings.otherSettings.campaignCategories} />
                        <p className="section-header">Fund Settings</p>
                        <div className="settings-section">
                            <div className="flex-justify">
                                <div className="column-half column-half-left">
                                    <UpdateSelect title="Default US Fund" options={tags.usFunds}
                                        value={settings.fundSettings.defaultUSFund}
                                        update={this.props.actions.updateDefaultFund.bind(this, SettingNames.DefaultUSFund)}
                                        loading={updatingSettings.defaultUSFund.loading}
                                        success={updatingSettings.defaultUSFund.success} />
                                </div>
                                <div className="column-half column-half-right">
                                    <UpdateSelect title="Default IL Fund" options={tags.israelFunds}
                                        value={settings.fundSettings.defaultIsraelFund}
                                        update={this.props.actions.updateDefaultFund.bind(this, SettingNames.DefaultILFund)}
                                        loading={updatingSettings.defaultIsraelFund.loading}
                                        success={updatingSettings.defaultIsraelFund.success} />
                                </div>
                            </div>
                            <div className="flex-justify">
                                <div className="column-half column-half-left">
                                    <TagInput title="Banks" values={settings.fundSettings.banks}
                                        add={this.props.actions.addTag.bind(this, TagNames.Banks)} name='bank'
                                        adding={updatingSettings.banks.add} deleting={updatingSettings.banks.delete}
                                        delete={this.props.actions.deleteTag.bind(this, TagNames.Banks)} />
                                </div>
                                <div className="column-half column-half-right" />
                            </div>
                        </div>

                        <p className="section-header">Admin Tools</p>
                        <div className="settings-section">
                            <div className="flex-justify">
                                <div className="column-half column-half-left">
                                    <FlushAiSummaries />
                                </div>
                                <div className="column-half column-half-right" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        loading: state.settings.systemSettings.loading || state.funds.fundsByDept.loading,
        settings: { ...state.settings.systemSettings.data },
        tags: {
            funds: state.funds.fundsByDept.all,
            israelFunds: state.funds.fundsByDept.IL,
            usFunds: state.funds.fundsByDept.US
        },
        updatingSettings: { ...state.systemSettings },
        reloadingSettings: { ...state.settings.systemSettings.reloading }
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({ ...settingsActions, getFunds }, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SystemSettingsPage);


// WEBPACK FOOTER //
// ./src/components/settingComponents/systemSettings/SystemSettingsPage.jsx